import { device } from '@monorepo/config';

export const checkDevice = (width) => {
  switch (true) {
    case width > 1550:
      return device.LARGE_SCREEN;

    case width <= 1550 && width > 1200:
      return device.LAPTOP;

    case width <= 1200 && width > 991:
      return device.TABLET_LANDSCAPE;

    case width <= 991 && width > 767:
      return device.TABLET_PORTRAIT;

    case width <= 767 && width > 576:
      return device.MOBILE_LANDSCAPE;

    case width < 576 && width > 350:
      return device.MOBILE_PORTRAIT;

    case width < 350:
      return device.EXTRA_SMALL_MOBILE;
  }
};
